import { motion } from "framer-motion";

// Light, premium palette scoped to the ambassadors page.
export const A = {
  bg: "bg-[#F6F0E7]", ivory: "bg-[#FBF8F3]", ink: "text-[#141013]", muted: "text-[#5E544D]",
  gold: "text-[#7A5418]", border: "border-[#E3D5C3]",
};

export const btnDark = "inline-flex h-14 items-center justify-center gap-2 rounded-full bg-[#141013] px-8 text-xs font-semibold uppercase tracking-[0.2em] text-[#FBF8F3] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#3A2A20]";
export const btnLight = "inline-flex h-14 items-center justify-center gap-2 rounded-full border border-[#141013] px-8 text-xs font-semibold uppercase tracking-[0.2em] text-[#141013] transition-[background-color,color] duration-300 hover:bg-[#141013] hover:text-[#FBF8F3]";

export function Eyebrow({ children }) {
  return <p className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-[#7A5418]">{children}</p>;
}

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div className={className} initial={{ y: 20 }} whileInView={{ y: 0 }}
      viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </motion.div>
  );
}
